import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { getSideMenuStatus } from 'src/app/angular-wallet-base/store/appSettings';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { openKycModal } from 'src/app/angular-wallet-base/utils';
import { ComplianceService } from '../../../angular-wallet-base/services/compliance.service';

@Component({
  selector: 'app-promo-modal',
  templateUrl: './promo-modal.component.html',
  styleUrls: ['./promo-modal.component.scss'],
})
export class PromoModalComponent implements OnInit {
  isDesktopMode:boolean;
  constructor(
    private modal: ModalController,
    protected store: Store<AppState>,
    private modalController: ModalController,
    private complianceService: ComplianceService,
    public appMode: AppModeService
  ) {
    this.store.select(getSideMenuStatus).subscribe(sideMenu => {
      // updare sidebar css variable to match the modal backdrop and position
      if (sideMenu) {
        document.documentElement.style.setProperty('--sidebar-width', '20px');
      } else {
        document.documentElement.style.setProperty('--sidebar-width', '300px');
      }
    });
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));

  }

  ngOnInit() { }

  closeModal() {
    this.modal.dismiss();
  }
  async goToKyc(){
    this.closeModal();
    var kycData = await this.complianceService.getKycCip();
      if (!kycData["passingLevel"]) {
        const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
        await openKycModal(sideMenuHidden, this.isDesktopMode, this.modalController);
        return;
      }
  }

}
